import { Alert, Alignment, Button, Classes, FormGroup, H5, Intent, Popover, Tab, Tabs, } from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { newEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { NFesStore } from "../../stores/nfe/NFesStore";
import { copyToClipboard, formatCpfOrCnpj, gerarPeriodos } from "../../utils";
import { MDBBtn, MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle } from "mdbreact";
import * as moment from "moment";
import { IEmpresa } from "../../model";
import { formatCnpj } from "../../utils";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { BootstrapTable, SearchField, TableHeaderColumn, } from "react-bootstrap-table";
import { toast } from "react-toastify";
import { DateRangePicker30 } from "../utils/DateRangePicker30";
import LoadingModal from "../loading/LoadingModal";
import { DateRangePicker10 } from "../utils/DateRangePicker10";
import { NotasStore } from "../../stores/notas/NotasStore";
import TarefasPage from "./TarefasPage";
import { TarefasStore } from "../../stores/notas/TarefasStore";
import { AppIcon } from "../utils/AppIcon";
import NFesExportPage from "./NFesExportPage";
import { XmlService } from "../../stores/services/XmlService";

const numeral = require("numeral");

interface NFesPageProps {}

interface NFesPageState {
  date1: string;
  date2: string;
}

@observer
export class NFesPage extends React.Component<NFesPageProps, NFesPageState> {

  obs = observable({
    selectedPeriod: [] as any,
    selectedEmpresa: newEmpresa() as IEmpresa,
    filtro: "" as string,
    tipo: "" as string,
    statusFilter: "todas" as string,
    loading: false as boolean,
    loading_danfes: false as boolean,
    loading_xmls: false as boolean,
    total_download: 0 as number,
    count_danfes: 0 as number,
    progress: 0.0 as number,
    list: [],
    listChaveEventos: [],
    loading_export: false as boolean,
    confirmCancelarOpen: false as boolean,
    notaCancelar: null as any,
  })
  static obs: any;

  constructor(props) {
    super(props);
    AppStore.setTitle('NF-e, NFC-e, CT-e e NFS-e');

    this.state = {
      date1: "",
      date2: ""
    }
  }

  /**
  * Inicializa os dados necessários ao montar o componente.
  *
  * A função limpa a lista de importações da store de NF-e, carrega as empresas
  * disponíveis e redefine os estados iniciais relacionados à empresa selecionada,
  * notas, lista de registros e chaves de eventos.
  *
  * Durante a inicialização:
  * - Limpa `NFesStore.obs.imps`.
  * - Carrega as empresas através de `NFesStore.loadEmpresas()`.
  * - Define uma nova empresa padrão em `this.obs.selectedEmpresa`.
  * - Zera o total de notas em `NotasStore.obs.total_notas`.
  * - Limpa as listas `this.obs.list` e `this.obs.listChaveEventos`.
  * - Verifica se existe uma empresa salva no `localStorage`.
  *
  * Caso exista uma empresa salva no `localStorage`:
  * - Recupera a empresa armazenada.
  * - Atualiza `this.obs.selectedEmpresa`.
  * - Atualiza `NFesStore.obs.selectedEmpresa`.
  * - Limpa novamente `NFesStore.obs.imps`.
  * - Altera a aba ativa para `"tarefas"` através de `handleChangeTab`.
  *
  * Ao final da execução, limpa todos os dados armazenados no `localStorage`.
  *
  * @async
  *
  * @returns {Promise<void>} Retorna uma Promise resolvida após a inicialização dos dados do componente.
  */

  async componentDidMount() {

    NFesStore.obs.imps = []

    this.obs.selectedEmpresa = newEmpresa();
    NotasStore.obs.total_notas = 0

    this.obs.list = []
    this.obs.listChaveEventos = []

    const temp: any = localStorage.getItem("69d3b5564533936abc4fde43")

    if (temp) {

      this.obs.selectedEmpresa = JSON.parse(temp).empresa;

      NFesStore.obs.selectedEmpresa = JSON.parse(temp).empresa;

      NFesStore.obs.imps = [];

      this.handleChangeTab("tarefas")

    }

    localStorage.removeItem("69d3b5564533936abc4fde43")

  }

  componentDidUpdate(prevProps, prevState) {

    if (prevState?.date1 !== this.state.date1 || prevState?.date2 !== this.state.date2 || 
      NotasStore.obs.total_notas !== NotasStore.obs.prev_total_notas) {

      NotasStore.obs.prev_total_notas = NotasStore.obs.total_notas;

      if (NotasStore.obs.total_notas > 20000 && this.obs.tipo == "NFC-E") {
        const start = this.state.date1 ? moment(this.state.date1, "YYYY-MM-DD") : null;
        const end = this.state.date2 ? moment(this.state.date2, "YYYY-MM-DD") : null;

        if (start) {
          const { start: finalStart, end: finalEnd } = this.clampPeriod(start, end, 10);

          const currentDiff = end && start ? end.diff(start, "days") + 1 : 10;
          const newDiff = finalEnd && finalStart ? finalEnd.diff(finalStart, "days") + 1 : 10;

          if (!end || currentDiff > newDiff) {
            this.setState({
              date1: finalStart.format("YYYY-MM-DD"),
              date2: finalEnd.format("YYYY-MM-DD"),
            });

            this.obs.selectedPeriod = [finalStart.toDate(), finalEnd.toDate()];
          }
        }
      }
    }
  }

  /**
  * Atualiza e ajusta o período selecionado quando há alteração nas datas ou no total de notas.
  *
  * A função é executada após atualizações do componente e verifica se houve mudança em `date1`,
  * `date2` ou no total de notas armazenado em `NotasStore.obs.total_notas`.
  *
  * Quando alguma dessas informações é alterada:
  * - Atualiza `NotasStore.obs.prev_total_notas` com o total atual de notas.
  * - Verifica se o total de notas é maior que `20000`.
  * - Aplica a regra somente quando o tipo selecionado for `"NFC-E"`.
  * - Caso exista uma data inicial, limita o período selecionado a no máximo 10 dias
  *   utilizando `clampPeriod`.
  * - Se não houver data final ou se o período atual for maior que o período permitido,
  *   atualiza `date1`, `date2` e `this.obs.selectedPeriod` com o novo intervalo ajustado.
  *
  * Essa validação evita consultas muito amplas para NFC-e quando há grande volume de notas.
  *
  * @param {object} prevProps Propriedades anteriores do componente.
  * @param {object} prevState Estado anterior do componente, usado para comparar alterações em `date1` e `date2`.
  *
  * @returns {void} Não possui retorno. A função apenas atualiza o estado e os observáveis quando necessário.
  */

  clampPeriod = (start: moment.Moment | null, end: moment.Moment | null, maxDays = 10) => {
    if (!start) return { start: null, end: null };

    let finalStart = start.clone();
    let finalEnd = end && end.isValid() ? end.clone() : start.clone().add(maxDays - 1, "days");

    if (finalEnd.isBefore(finalStart, "day")) {
      finalEnd = finalStart.clone().add(maxDays - 1, "days");
    }

    const diff = finalEnd.startOf("day").diff(finalStart.startOf("day"), "days") + 1;
    if (diff > maxDays) {
      finalEnd = finalStart.clone().add(maxDays - 1, "days");
    }

    return { start: finalStart, end: finalEnd };

  };

  /**
  * Atualiza o período selecionado a partir da alteração das datas no componente.
  *
  * A função recebe um array de datas, normalmente vindo de um seletor de período,
  * e converte os valores inicial e final para objetos `moment`.
  *
  * Durante o processamento:
  * - Obtém a data inicial a partir da primeira posição de `val`.
  * - Obtém a data final a partir da segunda posição de `val`.
  * - Valida se a data inicial existe e é válida.
  * - Caso a data inicial seja o primeiro dia do mês:
  *   - Usa a data final informada, quando existir.
  *   - Caso contrário, define automaticamente a data final como o último dia do mês.
  * - Caso a data inicial não seja o primeiro dia do mês:
  *   - Usa a data final somente se ela existir e for válida.
  *   - Caso contrário, mantém a data final como `null`.
  * - Atualiza o estado `date1` e `date2` no formato `"YYYY-MM-DD"`.
  * - Atualiza `this.obs.selectedPeriod` com as datas convertidas para `Date`.
  * - Limpa a lista de importações em `NFesStore.obs.imps`.
  * - Chama `handleTotalNotas` para recalcular ou buscar o total de notas do período selecionado.
  *
  * @param {any} val Array contendo a data inicial e, opcionalmente, a data final selecionada.
  *
  * @returns {void} Não possui retorno. A função apenas atualiza o estado, os observáveis e recalcula o total de notas.
  */

  handleDateChange = (val: any) => {
    const start = val?.[0] ? moment(val[0]) : null;
    const end = val?.[1] ? moment(val[1]) : null;
  
    let finalStart = null;
    let finalEnd = null;
  
    if (start && start.isValid()) {
      finalStart = start;
      finalEnd = start.date() === 1
        ? (end || start.clone().endOf('month'))
        : (end && end.isValid() ? end : null);
    }
  
    this.setState({
      date1: finalStart ? finalStart.format("YYYY-MM-DD") : null,
      date2: finalEnd ? finalEnd.format("YYYY-MM-DD") : null,
    });
  
    this.obs.selectedPeriod = [
      finalStart ? finalStart.toDate() : null,
      finalEnd ? finalEnd.toDate() : null,
    ];

    NFesStore.obs.imps = [];
    this.handleTotalNotas();

  };

  /**
  * Atualiza o período selecionado limitando o intervalo a no máximo 10 dias.
  *
  * A função recebe um array de datas, normalmente vindo de um seletor de período,
  * converte os valores para objetos `moment` e aplica a regra de limite de período
  * através de `clampPeriod`.
  *
  * Durante o processamento:
  * - Obtém a data inicial a partir da primeira posição de `val`.
  * - Obtém a data final a partir da segunda posição de `val`.
  * - Chama `clampPeriod` para ajustar o intervalo selecionado ao limite máximo de 10 dias.
  * - Atualiza o estado `date1` e `date2` no formato `"YYYY-MM-DD"`.
  * - Atualiza `this.obs.selectedPeriod` com as datas convertidas para `Date`.
  * - Limpa a lista de importações em `NFesStore.obs.imps`.
  * - Chama `handleTotalNotas` para recalcular ou buscar o total de notas do período selecionado.
  *
  * Essa função é utilizada quando o período selecionado precisa ser restringido
  * automaticamente, evitando consultas com intervalos maiores que o permitido.
  *
  * @param {any} val Array contendo a data inicial e, opcionalmente, a data final selecionada.
  *
  * @returns {void} Não possui retorno. A função apenas atualiza o estado, os observáveis e recalcula o total de notas.
  */

  handleDateChange10 = (val: any) => {
    const start = val?.[0] ? moment(val[0]) : null;
    const end = val?.[1] ? moment(val[1]) : null;

    const { start: finalStart, end: finalEnd } = this.clampPeriod(start, end, 10);

    this.setState({
      date1: finalStart ? finalStart.format("YYYY-MM-DD") : null,
      date2: finalEnd ? finalEnd.format("YYYY-MM-DD") : null,
    });

    this.obs.selectedPeriod = [
      finalStart ? finalStart.toDate() : null,
      finalEnd ? finalEnd.toDate() : null,
    ];

    NFesStore.obs.imps = [];
    this.handleTotalNotas();
  };

  /**
  * Cria um campo de busca customizado para filtragem da tabela/listagem.
  *
  * A função retorna um componente `SearchField` configurado com uma classe CSS
  * personalizada, valor inicial de busca e texto auxiliar no placeholder.
  *
  * Durante a renderização:
  * - Aplica a classe `"input-filter"` ao campo de busca.
  * - Define o valor inicial do campo usando `props.defaultSearch`.
  * - Exibe o placeholder `"Filtrar (Chave, Nº, Valor)"`, indicando que a busca
  *   pode ser feita por chave, número ou valor.
  *
  * @param {object} props Propriedades recebidas pelo campo de busca.
  * @param {string} props.defaultSearch Valor inicial utilizado no campo de busca.
  *
  * @returns {JSX.Element} Retorna um componente `SearchField` customizado.
  */

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Chave, Nº, Valor)"
      />
    );
  };

  /**
  * Atualiza o filtro de busca e recarcula o total de notas.
  *
  * A função é executada quando há alteração no campo de filtro. O valor digitado
  * pelo usuário é armazenado em `this.obs.filtro`, a lista de importações é limpa
  * e o total de notas é recalculado com base no novo filtro informado.
  *
  * Durante o processamento:
  * - Obtém o valor digitado através de `e.target.value`.
  * - Atualiza `this.obs.filtro` com o texto informado.
  * - Limpa a lista de importações em `NFesStore.obs.imps`.
  * - Chama `handleTotalNotas` para recalcular ou buscar o total de notas conforme o filtro atual.
  *
  * @param {any} e Evento disparado pela alteração do campo de filtro.
  *
  * @returns {void} Não possui retorno. A função apenas atualiza o filtro, limpa os dados carregados e recalcula o total de notas.
  */

  handleFilterChange = (e: any) => {
    var string = e.target.value;
    this.obs.filtro = string;
    NFesStore.obs.imps = [];
    this.handleTotalNotas();
  };

  /**
  * Atualiza o filtro de tipo e recalcula o total de notas.
  *
  * A função é executada quando há alteração no campo responsável pelo tipo da nota.
  * O valor selecionado ou digitado pelo usuário é armazenado em `this.obs.tipo`,
  * a lista de importações é limpa e o total de notas é recalculado com base no
  * novo tipo informado.
  *
  * Durante o processamento:
  * - Obtém o valor selecionado através de `e.target.value`.
  * - Atualiza `this.obs.tipo` com o tipo informado.
  * - Limpa a lista de importações em `NFesStore.obs.imps`.
  * - Chama `handleTotalNotas` para recalcular ou buscar o total de notas conforme o tipo atual.
  *
  * @param {any} e Evento disparado pela alteração do campo de tipo.
  *
  * @returns {void} Não possui retorno. A função apenas atualiza o tipo, limpa os dados carregados e recalcula o total de notas.
  */

  handleFilterTipoChange = (e: any) => {
    var string = e.target.value;
    this.obs.tipo = string;
    NFesStore.obs.imps = [];
    this.handleTotalNotas();
  };

  /**
  * Executa a busca de notas fiscais conforme os filtros selecionados.
  *
  * A função limpa a lista atual de resultados e valida se todos os filtros
  * obrigatórios foram preenchidos antes de iniciar a busca.
  *
  * Durante o processamento:
  * - Limpa `this.obs.list`.
  * - Verifica se uma empresa foi selecionada.
  * - Verifica se o tipo de XML foi informado.
  * - Verifica se a origem/filtro foi selecionada.
  * - Verifica se o período inicial e final foram preenchidos.
  * - Exibe mensagens de aviso via `toast.warning` caso algum campo obrigatório
  *   não tenha sido informado.
  * - Obtém os valores de empresa, tipo, filtro e período.
  * - Ativa o indicador de carregamento em `this.obs.loading`.
  * - Redefine `this.obs.statusFilter` para `"todas"`.
  * - Chama `NFesStore.setBusca` para executar a busca das notas fiscais.
  * - Desativa o indicador de carregamento ao final da busca.
  *
  * @async
  *
  * @returns {Promise<void>} Retorna uma Promise resolvida após a validação dos filtros
  * e execução da busca das notas fiscais.
  */

  handleBuscaClick = async () => {
    this.obs.list = []

    if (this.obs.selectedEmpresa.razao_social == "") {
      toast.warning('Você precisa selecionar uma empresa para filtrar.', {});
      return
    }

    if (this.obs.tipo == "") {
      toast.warning('Selecione um tipo de XML.', {});
      return
    }

    if (this.obs.filtro == "") {
      toast.warning('Selecione a origem.', {});
      return
    }

    if (this.state.date1 == null || this.state.date2 == null) {
      toast.warning('Selecione o período.', {});
      return
    }

    var empresa = this.obs.selectedEmpresa.cnpj;
    var filtro = this.obs.filtro;
    var tipo = this.obs.tipo;
    var date1 = this.state.date1;
    var date2 = this.state.date2;

    this.obs.loading = true
    this.obs.statusFilter = "todas"
    await NFesStore.setBusca(empresa, tipo, filtro, date1, date2);
    this.obs.loading = false

  }

  /**
  * Alterna a seleção de uma nota fiscal na listagem.
  *
  * A função é executada quando o usuário marca ou desmarca um item da lista.
  * O comportamento varia conforme o tipo de XML selecionado.
  *
  * Durante o processamento:
  * - Obtém o tipo atual através de `this.obs.tipo`.
  * - Caso o tipo seja `"NFS-E"`:
  *   - Chama `toggleItemNfse`, passando a lista atual e os dados da nota.
  *   - Utiliza a `chave` e o status `cancelada` da linha selecionada.
  * - Caso o tipo seja diferente de `"NFS-E"`:
  *   - Chama `toggleItem` para alternar a seleção do item pelo `row.id`.
  *   - Chama `toggleItem` novamente para alternar a chave da nota em `listChaveEventos`.
  *
  * Essa função mantém sincronizada a seleção visual dos itens e a lista de chaves
  * utilizadas posteriormente em operações relacionadas aos eventos das notas.
  *
  * @param {any} row Linha da tabela/listagem selecionada pelo usuário.
  * @param {string} row.chave Chave da nota fiscal selecionada.
  * @param {string|number} row.id Identificador do item selecionado.
  * @param {boolean} row.cancelada Indica se a NFS-e está cancelada.
  *
  * @returns {void} Não possui retorno. A função apenas altera a seleção dos itens nas listas observáveis.
  */

  handleCheckChange = (row: any) => {
    const { tipo } = this.obs;

    if (tipo === "NFS-E") {

      this.toggleItemNfse(this.obs.list, { chave: row.chave, cancelada: row.cancelada });

    } else {

      this.toggleItem(this.obs.list, row.id);
      this.toggleItem(this.obs.listChaveEventos, row.chave);

    }

  };

  /**
  * Alterna a presença de uma NFS-e em uma lista com base na chave da nota.
  *
  * A função verifica se já existe um item na lista com a mesma `chave`
  * informada no objeto `value`.
  *
  * Durante o processamento:
  * - Procura na lista um item cuja propriedade `chave` seja igual à chave de `value`.
  * - Caso o item não exista na lista, adiciona `value`.
  * - Caso o item já exista, remove o item da lista.
  * - Retorna a própria lista atualizada.
  *
  * Essa função é usada para controlar a seleção e remoção de NFS-e,
  * evitando duplicidade de itens com a mesma chave.
  *
  * @param {any[]} list Lista de NFS-e selecionadas.
  * @param {any} value Objeto da NFS-e que deve ser adicionada ou removida.
  * @param {string} value.chave Chave da NFS-e usada para identificar o item na lista.
  *
  * @returns {any[]} Retorna a lista atualizada após adicionar ou remover o item.
  */

  toggleItemNfse = (list: any[], value: any) => {

    const index = list.findIndex(i => i.chave === value.chave);

    if (index === -1) {
      list.push(value);
    } else {
      list.splice(index, 1);
    }

    return list;

  };

  /**
  * Alterna a presença de um valor em uma lista.
  *
  * A função verifica se o valor informado já existe na lista. Caso não exista,
  * adiciona o valor ao array. Caso já exista, remove o valor da lista.
  *
  * Durante o processamento:
  * - Procura o índice de `value` dentro de `list`.
  * - Caso o valor não seja encontrado, adiciona `value` ao final da lista.
  * - Caso o valor já exista, remove o item correspondente da lista.
  *
  * Essa função é usada para controlar seleção e remoção de itens em listas,
  * como IDs de notas ou chaves de eventos selecionadas.
  *
  * @param {any[]} list Lista que será atualizada.
  * @param {any} value Valor que deve ser adicionado ou removido da lista.
  *
  * @returns {void} Não possui retorno. A função altera diretamente a lista recebida por referência.
  */

  toggleItem = (list: any[], value: any) => {

    const index = list.indexOf(value);

    if (index === -1) {
      list.push(value);
    } else {
      list.splice(index, 1);
    }

  };

  /**
  * Marca ou desmarca todos os itens da listagem.
  *
  * A função é executada quando o usuário seleciona ou remove a seleção geral
  * da tabela/listagem. Antes de aplicar a nova seleção, as listas de itens
  * selecionados e chaves de eventos são limpas.
  *
  * Durante o processamento:
  * - Limpa `this.obs.list`.
  * - Limpa `this.obs.listChaveEventos`.
  * - Verifica se a ação recebida em `isSelect` representa seleção total.
  * - Caso `isSelect` seja verdadeiro e o tipo atual seja `"NFS-E"`:
  *   - Preenche `this.obs.list` com objetos contendo a `chave` e o status
  *     `cancelada` de cada item presente em `NFesStore.obs.imps`.
  * - Caso `isSelect` seja verdadeiro e o tipo seja diferente de `"NFS-E"`:
  *   - Percorre todos os itens de `NFesStore.obs.imps`.
  *   - Adiciona o `_id` de cada item em `this.obs.list`.
  *   - Adiciona a `chave` de cada item em `this.obs.listChaveEventos`.
  *
  * Essa função mantém a seleção em massa compatível com as regras específicas
  * de NFS-e e dos demais tipos de XML.
  *
  * @param {boolean} isSelect Indica se todos os itens devem ser selecionados ou desmarcados.
  * @param {any[]} rows Linhas recebidas pelo evento de seleção da tabela.
  *
  * @returns {void} Não possui retorno. A função apenas atualiza as listas observáveis de itens selecionados.
  */

  onSelectAll = (isSelect, rows) => {

    this.obs.list = []
    this.obs.listChaveEventos = []

    if (isSelect) {

      if (this.obs.tipo == "NFS-E") {

        this.obs.list = NFesStore.obs.imps?.map(imp => {
          return ({ chave: imp.chave, cancelada: (imp.cancelada || false) })
        });

      } else {

        for (const imp of NFesStore.obs.imps) {
          this.obs.list.push(imp._id);
          this.obs.listChaveEventos.push(imp.chave);
        }

      }

    }

  };

  /**
  * Controla a seleção de uma linha da tabela/listagem.
  *
  * A função é executada quando o usuário tenta selecionar ou desselecionar uma linha.
  * Antes de alterar a seleção, verifica se o item está disponível para seleção.
  *
  * Durante o processamento:
  * - Verifica se o status da linha é `"Indisponível"`.
  * - Caso o item esteja indisponível, retorna `false` e impede a seleção da linha.
  * - Caso o item esteja disponível, chama `handleCheckChange` para alternar a seleção do item.
  *
  * Essa função evita que notas ou registros indisponíveis sejam selecionados para operações posteriores.
  *
  * @param {any} row Linha da tabela/listagem selecionada pelo usuário.
  * @param {boolean} isSelected Indica se a linha está sendo selecionada ou desselecionada.
  * @param {any} e Evento disparado pela ação de seleção da linha.
  *
  * @returns {boolean|void} Retorna `false` quando a linha está indisponível. Caso contrário, apenas executa a alteração da seleção.
  */

  handleRowSelect = (row, isSelected, e) => {
    if (row.status == "Indisponível") {
      return false;
    } else {
      this.handleCheckChange(row);
    }
  };

  /**
  * Realiza o download dos XMLs selecionados.
  *
  * A função valida se há XMLs selecionados antes de iniciar o download.
  * Caso nenhum item tenha sido selecionado, exibe uma mensagem de aviso e
  * interrompe a execução.
  *
  * Durante o processamento:
  * - Verifica se `this.obs.list` possui ao menos um item selecionado.
  * - Exibe uma mensagem via `toast.warning` caso nenhum XML tenha sido selecionado.
  * - Define os IDs que serão enviados para download:
  *   - Para `"NFS-E"`, utiliza a propriedade `chave` dos itens selecionados.
  *   - Para os demais tipos, utiliza diretamente os valores de `this.obs.list`.
  * - Monta o objeto `documento` com os dados necessários para a busca/download:
  *   - IDs selecionados.
  *   - Filtro/origem.
  *   - Tipo do XML.
  *   - CNPJ da empresa selecionada.
  *   - Período inicial e final.
  * - Ativa o indicador de carregamento `this.obs.loading_xmls`.
  * - Chama `NFesStore.download_xml` para realizar o download dos XMLs.
  * - Desativa o indicador de carregamento ao final do processo.
  *
  * @async
  *
  * @returns {Promise<void>} Retorna uma Promise resolvida após a tentativa de download dos XMLs selecionados.
  */

  handleDownload = async () => {

    if (this.obs.list.length < 1) {
      toast.warning('Você precisa selecionar os XMLs desejados para realizar o download.', {});
      return
    }

    const ids =
      this.obs.tipo === "NFS-E"
        ? this.obs.list.map(x => x.chave)
        : this.obs.list;

    var documento = {
      ids: ids,
      filtro: this.obs.filtro,
      tipo: this.obs.tipo,
      empresa: this.obs.selectedEmpresa.cnpj,
      data1: this.state.date1,
      data2: this.state.date2,
    };

    this.obs.loading_xmls = true;

    await XmlService.downloadXml("notas_xml", documento, this.obs.selectedEmpresa.razao_social);

    this.obs.loading_xmls = false;

  };

  /**
  * Realiza o download dos eventos vinculados aos XMLs selecionados.
  *
  * A função monta uma lista de chaves das notas selecionadas e envia os dados
  * necessários para que a store execute o download dos eventos relacionados.
  *
  * Durante o processamento:
  * - Define as chaves que serão enviadas para download:
  *   - Para `"NFS-E"`, utiliza a propriedade `chave` dos itens selecionados em `this.obs.list`.
  *   - Para os demais tipos, utiliza as chaves armazenadas em `this.obs.listChaveEventos`.
  * - Monta o objeto `documento` contendo:
  *   - Chaves dos XMLs selecionados.
  *   - CNPJ da empresa selecionada.
  *   - Período inicial e final.
  *   - Filtro/origem selecionado.
  *   - Tipo do XML.
  * - Verifica se há ao menos uma chave selecionada.
  * - Caso nenhuma chave tenha sido selecionada, exibe uma mensagem de aviso via `toast.warning`
  *   e interrompe a execução.
  * - Ativa o indicador de carregamento `this.obs.loading_xmls`.
  * - Chama `NFesStore.download_eventos` para realizar o download dos eventos.
  * - Desativa o indicador de carregamento ao final do processo.
  *
  * @async
  *
  * @returns {Promise<void>} Retorna uma Promise resolvida após a tentativa de download dos eventos selecionados.
  */

  handleEventos = async () => {

    const ids =
      this.obs.tipo === "NFS-E"
        ? this.obs.list.map(x => x.chave)
        : this.obs.listChaveEventos;

    var documento = {
      chaves: ids,
      empresa: this.obs.selectedEmpresa.cnpj,
      data1: this.state.date1,
      data2: this.state.date2,
      filtro: this.obs.filtro,
      tipo: this.obs.tipo
    };

    if (documento.chaves.length < 1) {
      toast.warning('Você precisa selecionar os XMLs desejados para realizar o download.', {});
      return
    }

    this.obs.loading_xmls = true;

    await XmlService.download_eventos("notas_xml", documento, this.obs.selectedEmpresa.razao_social);

    this.obs.loading_xmls = false;

  };

  /**
  * Gera ou realiza o download da DANFE dos XMLs selecionados.
  *
  * A função valida se o usuário possui permissão para gerar DANFE e, em seguida,
  * verifica se há XMLs selecionados para a operação.
  *
  * Durante o processamento:
  * - Verifica se a conta do usuário está em período de teste.
  * - Caso esteja em período de teste, exibe uma mensagem de aviso via `toast.warning`
  *   e não permite a geração da DANFE.
  * - Caso a conta não esteja em período de teste:
  *   - Verifica se existe ao menos um XML selecionado em `this.obs.list`.
  *   - Caso nenhum XML esteja selecionado, exibe uma mensagem de aviso e interrompe a execução.
  *   - Monta o objeto `ids` com os dados necessários para geração da DANFE:
  *     - IDs dos XMLs selecionados.
  *     - Filtro/origem selecionado.
  *     - Tipo do XML.
  *     - Razão social da empresa.
  *     - CNPJ da empresa.
  *     - Período inicial e final.
  *   - Ativa o indicador de carregamento `this.obs.loading_danfes`.
  *   - Caso exista apenas um XML selecionado, chama `NFesStore.view_danfe`
  *     para visualizar a DANFE.
  *   - Caso exista mais de um XML selecionado, chama `NFesStore.download_danfe`
  *     para baixar as DANFEs em lote.
  *   - Desativa o indicador de carregamento ao final do processo.
  *
  * @async
  *
  * @returns {Promise<void>} Retorna uma Promise resolvida após a tentativa de geração,
  * visualização ou download da DANFE.
  */

  handleDanfe = async () => {

    let is_teste = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;

    if (is_teste) {
      toast.warning("No período de testes, você não tem permissão para gerar uma DANFE.", {});

    } else {

      if (this.obs.list.length < 1) {
        toast.warning('Você precisa selecionar os XMLs desejados para gerar.', {});
        return
      }

      var ids = {
        ids: this.obs.list,
        filtro: this.obs.filtro,
        tipo: this.obs.tipo,
        razao_social: this.obs.selectedEmpresa.razao_social,
        empresa: this.obs.selectedEmpresa.cnpj,
        data1: this.state.date1,
        data2: this.state.date2,
      };

      this.obs.loading_danfes = true;

      if (this.obs.list.length == 1) {

        await XmlService.downloadDanfeNotas("notas_xml", this.obs.selectedEmpresa, ids);

      }

      if (this.obs.list.length > 1) {

        await XmlService.download_danfe("notas_xml", ids, this.obs.selectedEmpresa.razao_social);

      }

      this.obs.loading_danfes = false;

    }
  };

  /**
  * Renderiza o texto informativo com o intervalo e o total de resultados exibidos.
  *
  * A função retorna um elemento `<p>` contendo a quantidade de registros
  * atualmente exibidos na listagem, informando o item inicial, o item final
  * e o total geral de resultados encontrados.
  *
  * Durante a renderização:
  * - Exibe o texto no formato: `"Mostrando {start} a {to} de {total} resultados."`.
  * - Aplica uma margem à esquerda de `12px` no elemento.
  * - Adiciona espaçamento extra ao final do texto usando `&nbsp;`.
  *
  * @param {number} start Número do primeiro item exibido na página atual.
  * @param {number} to Número do último item exibido na página atual.
  * @param {number} total Quantidade total de resultados encontrados.
  *
  * @returns {JSX.Element} Retorna um parágrafo com o resumo da paginação.
  */

  renderShowsTotal(start, to, total) {
    return (
      <p style={{ marginLeft: 12 }}>
        Mostrando {start} a {to} de {total} resultados.&nbsp;&nbsp;
      </p>
    );
  }

  /**
  * Busca ou recalcula o total de notas conforme os filtros selecionados.
  *
  * A função valida se todos os dados obrigatórios para a consulta estão preenchidos
  * antes de montar os parâmetros e chamar a store responsável pelo total de notas.
  *
  * Durante o processamento:
  * - Verifica se existe uma empresa selecionada com CNPJ.
  * - Verifica se a origem/filtro foi informada.
  * - Verifica se o tipo/modelo do XML foi informado.
  * - Verifica se existe um período selecionado.
  * - Interrompe a execução caso o período contenha `"Data inválida"`.
  * - Interrompe a execução caso o período contenha valores `null`.
  * - Monta o objeto `params` com:
  *   - CNPJ da empresa selecionada.
  *   - Modelo/tipo do XML.
  *   - Tipo/origem do filtro.
  *   - Período gerado por `gerarPeriodos`.
  * - Chama `NotasStore.handleTotalNotas` para buscar ou atualizar o total de notas.
  *
  * @async
  *
  * @returns {Promise<void>} Retorna uma Promise resolvida após a tentativa de busca ou recálculo do total de notas.
  */

  async handleTotalNotas() {

    if(!this.obs.selectedEmpresa.cnpj) return
    if(!this.obs.filtro) return
    if(!this.obs.tipo) return
    if(!this.obs.selectedPeriod.length) return
    if(this.obs.selectedPeriod.includes("Data inválida")) return
    if(this.obs.selectedPeriod.includes(null)) return

    let params = {
      cnpj: this.obs.selectedEmpresa.cnpj,
      modelo: this.obs.tipo,
      tipo: this.obs.filtro,
      periodo: gerarPeriodos(this.obs.selectedPeriod)
    }

    await NotasStore.handleTotalNotas(params)

  }

  /**
  * Altera a aba selecionada no componente.
  *
  * A função recebe o identificador da aba e atualiza a aba ativa na store de NF-e.
  * Quando a aba selecionada é `"tarefas"`, valida se existe uma empresa selecionada
  * antes de carregar a listagem de tarefas.
  *
  * Durante o processamento:
  * - Converte `tabId` para `string`.
  * - Verifica se a aba selecionada é `"tarefas"`.
  * - Caso seja a aba de tarefas:
  *   - Valida se existe uma empresa selecionada com CNPJ.
  *   - Caso nenhuma empresa esteja selecionada, exibe um aviso via `toast.warn`
  *     e interrompe a execução.
  *   - Chama `TarefasStore.handleTasksPaged(1)` para carregar a primeira página
  *     das tarefas.
  * - Atualiza `NFesStore.obs.selectedTab` com a aba selecionada.
  *
  * @param {string|number} tabId Identificador da aba que deve ser selecionada.
  *
  * @returns {void} Não possui retorno. A função apenas valida a empresa selecionada,
  * carrega tarefas quando necessário e atualiza a aba ativa.
  */

  handleChangeTab(tabId) {

    if (String(tabId) == "tarefas") {

      if (!this.obs.selectedEmpresa.cnpj){
        toast.warn("Selecione a empresa!")
        return
      }

      TarefasStore.handleTasksPaged(1);

    } 

    NFesStore.obs.selectedTab = String(tabId)

  }

  /**
  * Confirma o cancelamento de uma nota fiscal selecionada.
  *
  * A função envia para a store os dados necessários para executar o cancelamento
  * da nota fiscal, utilizando as informações da empresa selecionada, da linha
  * escolhida e dos filtros atuais da tela.
  *
  * Durante o processamento:
  * - Obtém o CNPJ da empresa selecionada.
  * - Obtém a data/hora de emissão da nota através de `row.dhemi`.
  * - Obtém a chave da nota através de `row.chave`.
  * - Utiliza o tipo de XML selecionado em `this.obs.tipo`.
  * - Utiliza o filtro/origem selecionado em `this.obs.filtro`.
  * - Obtém a UF da empresa selecionada.
  * - Chama `NFesStore.cancelar_nota` para realizar o cancelamento da nota.
  *
  * @async
  *
  * @param {any} row Linha da tabela/listagem referente à nota que será cancelada.
  * @param {string|number} row.dhemi Data/hora de emissão da nota, usada no cancelamento.
  * @param {string} row.chave Chave de acesso da nota fiscal que será cancelada.
  *
  * @returns {Promise<void>} Retorna uma Promise resolvida após a tentativa de cancelamento da nota.
  */

  async confirmarCancelamento(row: any) {

    await NFesStore.cancelar_nota(this.obs.selectedEmpresa.cnpj, row.dhemi, row.chave, this.obs.tipo, this.obs.filtro, this.obs.selectedEmpresa.uf);

  }

  /**
  * Retorna os itens selecionados conforme o tipo de nota atual.
  *
  * A função verifica o tipo selecionado em `this.obs.tipo` e retorna a lista
  * de itens selecionados no formato esperado para as operações posteriores.
  *
  * Durante o processamento:
  * - Caso o tipo seja `"NFS-E"`:
  *   - Percorre `this.obs.list`.
  *   - Retorna apenas as chaves dos itens selecionados.
  * - Caso o tipo seja diferente de `"NFS-E"`:
  *   - Retorna diretamente `this.obs.list`.
  *
  * Essa função centraliza a regra de seleção, pois NFS-e armazena os itens
  * selecionados como objetos, enquanto os demais tipos utilizam diretamente
  * a lista de IDs.
  *
  * @returns {any[]} Retorna a lista de itens selecionados, podendo conter chaves de NFS-e ou IDs dos demais tipos de XML.
  */

  itens_selecteds() {

    return this.obs.tipo === "NFS-E"
      ? this.obs.list.map(x => x.chave)
      : this.obs.list;

  }

  /**
  * Exporta as notas fiscais filtradas para Excel.
  *
  * A função valida se todos os filtros obrigatórios foram preenchidos antes de
  * solicitar a exportação dos dados. Caso algum campo esteja ausente ou inválido,
  * exibe uma mensagem de aviso e interrompe a execução.
  *
  * Durante o processamento:
  * - Verifica se uma empresa foi selecionada.
  * - Verifica se o tipo/modelo do XML foi informado.
  * - Verifica se a origem/filtro foi selecionada.
  * - Verifica se o período inicial e final foram preenchidos e são válidos.
  * - Monta o objeto `data` com os dados necessários para a exportação:
  *   - CNPJ da empresa.
  *   - Razão social da empresa.
  *   - Origem/tipo do filtro.
  *   - Modelo/tipo do XML.
  *   - Data inicial.
  *   - Data final.
  * - Ativa o indicador de carregamento `this.obs.loading_export`.
  * - Chama `NFesStore.handleExport` para solicitar a geração/exportação do Excel.
  * - Desativa o indicador de carregamento ao final da requisição.
  * - Caso a exportação seja iniciada com sucesso, altera a aba ativa para `"nfe_export"`.
  *
  * @async
  *
  * @returns {Promise<void>} Retorna uma Promise resolvida após a tentativa de exportação
  * dos dados para Excel.
  */

  async handleExcel() {

    if (!this.obs.selectedEmpresa.cnpj) {
      toast.warning('Selecione uma empresa.', {});
      return
    }

    if (!this.obs.tipo) {
      toast.warning('Selecione um Tipo.', {});
      return
    }

    if (!this.obs.filtro) {
      toast.warning('Selecione uma Origem.', {});
      return
    }

    if (!this.state.date1 || !this.state.date2 || this.state.date1 == "Data inválida" || this.state.date2 == "Data inválida") {
      toast.warning('Selecione um período válido.', {});
      return
    }

    const data = {
      cnpj: this.obs.selectedEmpresa.cnpj,
      razao_social: this.obs.selectedEmpresa.razao_social,
      tipo: this.obs.filtro,
      modelo: this.obs.tipo,
      date_start: this.state.date1,
      date_end: this.state.date2
    }

    this.obs.loading_export = true

    const resp = await NFesStore.handleExport(data);

    this.obs.loading_export = false

    if(resp) {

      this.handleChangeTab("nfe_export")

    }

  }

  render() {
    let niveis_acesso = AppStore.obs1.usuario
      ? AppStore.obs1.usuario.niveis_acesso
      : [""];

    const selectRowProp = {
      mode: "checkbox",
      clickToSelect: false,
      onSelectAll: this.onSelectAll,
      columnWidth: "40px",
      onSelect: this.handleRowSelect,
      bgColor: "rgba(27, 98, 111, 0.1)",
      selected: this.itens_selecteds()
    };

    const handleBuscaDanfe = async (row) => {

      const ids = this.obs.tipo == "NFS-E"
        ? [{chave: row.chave, cancelada: row.cancelada}]
        : row.id.split(",")

      await XmlService.downloadDanfeNotas("notas_xml", this.obs.selectedEmpresa, { filtro: this.obs.filtro, tipo: this.obs.tipo, empresa: this.obs.selectedEmpresa.cnpj, data1: this.state.date1, data2: this.state.date2, ids: ids });

    };

    function copyChave(token: string) {
      copyToClipboard(token);
      toast.success('Chave de Acesso Copiada', {});
    }

    function copyChaveFormatter(cell, row) {
      let danfeFormatter = <></>;
      danfeFormatter = (
        <span onClick={() => copyChave(row.chave)}>{row.chave}</span>
      );
      return danfeFormatter;
    }

    function buttonFormatter(cell, row) {
      let danfeFormatter = <></>;
      danfeFormatter = (
        <img
          src="/images/danfe_icon.svg"
          width={25}
          onClick={() => handleBuscaDanfe(row)}
          style={{ cursor: "pointer", display: "inline-block" }}
        />
      );
      return danfeFormatter;
    }

    const buttonCancelada = (cell, row) => {
      if (row.cancelada) {
        return <b style={{ color: "#d95050" }}>SIM</b>
      }

      return <b>NÃO</b>
    }

    const valorFormatter = (cell, row) => {
      if (row.cancelada) {
        return <span className="valor-cancelado">{cell}</span>
      }
      return cell;
    }

    const rowClassNameFormat = (row: any) => {
      return row.cancelada ? "row-nfe-cancelada" : "";
    }

    const handleStatusFilterChange = (e: any) => {
      this.obs.statusFilter = e.target.value;
    }

    const filteredImps = NFesStore.obs.imps?.filter(imp => {
      if (this.obs.statusFilter === "ativas") return !imp.cancelada;
      if (this.obs.statusFilter === "canceladas") return !!imp.cancelada;
      return true;
    });

    let totalValorAtivas = 0;
    let totalValorCanceladas = 0;

    let items = filteredImps?.map(imp => {
      let cnpjOrig = imp.cnpj_origem ? formatCpfOrCnpj(imp.cnpj_origem) : "";
      let cnpjDest = imp.cnpj_destino ? formatCpfOrCnpj(imp.cnpj_destino) : "Não possui";

      const valor = Number(imp.valor) || 0;
      if (imp.cancelada) {
        totalValorCanceladas += valor;
      } else {
        totalValorAtivas += valor;
      }

      return (
        {
          id: this.obs.tipo == "NFS-E" ? imp.chave : imp._id,
          chave: imp.chave,
          numero: imp.nnf,
          dhemi: imp.dhemi,
          tipo: imp.tipo == undefined
            ? "NF-e"
            : imp.tipo == "NFCE"
              ? "NFC-e"
              : imp.tipo == "CT-E"
                ? "CT-e"
                : imp.tipo == "NF-E"
                  ? "NF-e"
                  : imp.tipo,
          cnpj: cnpjOrig + " / " + cnpjDest,
          emissao: imp.tipo == "NF-E"
            ? moment(imp.dhemi).add(3, "hours").format("DD/MM/YY") + " às " + moment(imp.dhemi).add(3, "hours").format("HH:mm")
            : moment(imp.dhemi).format("DD/MM/YY") + " às " + moment(imp.dhemi).format("HH:mm"),
          valor: "R$ " + numeral(imp.valor).format("0,0.00"),
          valor_num: Number(imp.valor) || 0,
          Origem: imp.cnpj_origem != NFesStore.obs.cnpj_selected
            ? "Entrada"
            : "Saída",
          cancelada: (imp.cancelada || false)
        }
      );
    });


    let empresaText = this.obs.selectedEmpresa.razao_social != ""
      ? `${this.obs.selectedEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectedEmpresa.cnpj)
      })`
      : "Selecione uma empresa";

    const options = {
      page: 1, // which page you want to show as default
      sizePerPageList: [{
        text: "20",
        value: 20,
      }, {
        text: "50",
        value: 50,
      }, {
        text: "100",
        value: 100,
      }], // you can change the dropdown list for size per page
      sizePerPage: 20, // which size per page you want to locate as default
      pageStartIndex: 1, // where to start counting the pages
      paginationSize: 4, // the pagination bar size.
      prePage: "Ante", // Previous page button text
      nextPage: "Próxima", // Next page button text
      firstPage: "Início", // First page button text
      lastPage: "Última", // Last page button text
      paginationShowsTotal: this.renderShowsTotal, // Accept bool or function
      searchField: this.createCustomSearchField,
    };

    const actionFormatter = (cell, row) => {
      return (
        <Popover popoverClassName={`${Classes.POPOVER_CONTENT_SIZING} popOverNfse`}>
          {!row.cancelada ? ( 
          <Button
            color="default"
            small
          >
            Cancelar Nota
          </Button>

          ) : <>  </>}
          <div>
            <H5>Cancelar Nota?</H5>
            <p>Você confirma o cancelamento da nota <b>{row.chave}</b>?</p>
            <p>
              Obs: O cancelamento no FIPO apenas implica no cálculo de impostos, não há validade jurídica.
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 15,
              }}
            >
              <Button
                className={Classes.POPOVER_DISMISS}
                style={{ marginRight: 10 }}
              >
                Cancelar
              </Button>
              <Button
                intent="danger"
                className={Classes.POPOVER_DISMISS}
                onClick={(e) => this.confirmarCancelamento(row)}
              >
                Confirmar
              </Button>
            </div>
          </div>
        </Popover>
      );
    };

    return (

      <Tabs
          id="tabs"
          className={"tabsCalculos"}
          selectedTabId={NFesStore.obs.selectedTab}
          onChange={(tabId) => this.handleChangeTab(tabId)}
          renderActiveTabPanelOnly={true}
      >
        <Tab id="notas" title="Notas" panel={

          <div>

          <LoadingModal open={this.obs.loading} onClose={() => this.obs.loading = false} title={"Buscando XMLs"} />
          <LoadingModal open={this.obs.loading_danfes} onClose={() => this.obs.loading_danfes = false} title={"Gerando DANFES"} />
          <LoadingModal open={this.obs.loading_xmls} onClose={() => this.obs.loading_xmls = false} title={"Gerando XMLs"} />
          <LoadingModal open={this.obs.loading_export} onClose={() => this.obs.loading_export = false} title={"Solicitando"} />

          <div className="nfes-filtros">
            <div className="filtro-item filtro-empresa">
              <FormGroup label="Empresa" className="empresaSelect">
                <EmpresaSelect
                  items={EmpresaStore.sortedEmpresas}
                  itemRenderer={renderEmpresa}
                  itemPredicate={filterEmpresa}
                  onItemSelect={(e: IEmpresa) => {
                    this.obs.selectedEmpresa = e;
                    NFesStore.obs.selectedEmpresa = e;
                    this.handleTotalNotas();
                    NFesStore.obs.imps = [];
                  }}
                  inputProps={{ placeholder: "Filtrar uma empresa" }}
                >
                  <Button
                    text={empresaText}
                    rightIcon="double-caret-vertical"
                    alignText={Alignment.LEFT}
                  />
                </EmpresaSelect>
              </FormGroup>
            </div>

            <div className="filtro-item filtro-tipo">
              <FormGroup label="Tipo" className="nz-horizontal-field selectFullWidth">
                <select
                  onChange={this.handleFilterTipoChange}
                  value={this.obs.tipo}
                  className="bp3-button bp3-align-left"
                >
                  <option value="">Selecione</option>
                  <option value="NF-E">NF-E</option>
                  <option value="NFC-E">NFC-E</option>
                  <option value="CT-E">CT-E</option>
                  <option value="NFS-E">NFS-E</option>
                </select>
              </FormGroup>
            </div>

            <div className="filtro-item filtro-origem">
              <FormGroup label="Origem" className="nz-horizontal-field selectFullWidth">
                <select
                  onChange={this.handleFilterChange}
                  value={this.obs.filtro}
                  className="bp3-button bp3-align-left"
                >
                  <option value="">Selecione</option>
                  {this.obs.tipo == "NFS-E"
                    ?
                    <>
                      <option value="Entrada">Serviços Tomados</option>
                      <option value="Saída">Serviços Prestados</option>
                    </>
                    :
                    <>
                      <option value="Entrada">Entrada</option>
                      <option value="Saída">Saída</option>
                    </>
                  }
                </select>
              </FormGroup>
            </div>
            </div>

          <div className="nfes-filtros">
            <div className="filtro-item filtro-periodo">
              <FormGroup label="Período" className="inputsPeriodoCalculos">
                {NotasStore.obs.total_notas > 20000 && this.obs.tipo == "NFC-E" ?
                  <DateRangePicker10
                    onChange={this.handleDateChange10}
                    value={this.obs.selectedPeriod}
                  />
                  :
                  <DateRangePicker30
                    onChange={this.handleDateChange}
                    value={this.obs.selectedPeriod}
                    disabled={false}
                  />
                }
              </FormGroup>
            </div>

            <div className="filtro-item filtro-acao">
                <MDBBtn
                  className="btnDefault btnBuscarNfe"
                  onClick={this.handleBuscaClick}
                  disabled={niveis_acesso.indexOf("h1") == -1}
                  style={{marginTop: 26}}
                >
                  Buscar
                </MDBBtn>
            </div>
          </div>

          <p><b>Total de notas do período do mês selecionado: </b> {NotasStore.obs.total_notas}</p>

          {NotasStore.obs.total_notas > 20000 && this.obs.tipo == "NFC-E" ?
            <p style={{ color: "rgba(255, 0, 0, 0.82)" }}>
              <b>Observação: Para volumes superiores a 20.000 notas de NFC-e, a consulta fica limitada a um período máximo de 10 dias.</b>
            </p>
          : <></>}

          <div style={{display: "flow-root", width: "100%", marginBottom: -20 }}>

            <div style={{float: "left"}}>
              {NFesStore.obs.imps.length 
                ? (<FormGroup label="Exibir" style={{ width: 200 }}>
                    <select
                      onChange={handleStatusFilterChange}
                      value={this.obs.statusFilter}
                      className="bp3-button bp3-align-left"
                      style={{ minWidth: 180 }}
                    >
                      <option value="todas">Todas</option>
                      <option value="ativas">Apenas Ativas</option>
                      <option value="canceladas">Apenas Canceladas</option>
                    </select>
                  </FormGroup>)
                : <></>
              }
            </div>

            <div style={{textAlign: "right"}}>
              <FormGroup label={"\u200B"}>
                <MDBDropdown>
                  <MDBDropdownToggle caret className="btnDefault btnExportSelecionados" disabled={niveis_acesso.indexOf("h3") == -1}>
                    Com os Selecionados
                  </MDBDropdownToggle>
                  <MDBDropdownMenu basic>
                    <MDBDropdownItem onClick={this.handleDownload} className="actionMani d-flex align-items-center">
                      <AppIcon color="#0f373e" name="code_xml"/>&nbsp;<span className="ms-2">Download XML</span>
                    </MDBDropdownItem>
                    <MDBDropdownItem onClick={this.handleDanfe} className="actionMani d-flex align-items-center">
                      <AppIcon color="#0f373e" name="docs"/>&nbsp;<span className="ms-2">DANFE em PDF</span>
                    </MDBDropdownItem>
                    <MDBDropdownItem onClick={this.handleEventos} className="actionMani d-flex align-items-center">
                      <AppIcon color="#0f373e" name="calendar_today"/>&nbsp;<span className="ms-2">Download Eventos</span>
                    </MDBDropdownItem>
                    {/* <MDBDropdownItem onClick={() => this.handleExcel()} className="actionMani d-flex align-items-center">
                      <AppIcon color="#0f373e" name="table"/>&nbsp;<span className="ms-2">Exportar Excel</span>
                    </MDBDropdownItem> */}
                  </MDBDropdownMenu>
                </MDBDropdown>
              </FormGroup>
            </div>

          </div>

          {/* <div className="summary-totals" style={{marginBottom: -20}}>
            <div className="summary-total-item">
              <span className="summary-total-label">Total não canceladas</span>
              <span className="summary-total-value">{numeral(totalValorAtivas).format("$ 0,0.00")}</span>
            </div>
            <div className="summary-total-item">
              <span className="summary-total-label">Total canceladas</span>
              <span className="summary-total-value summary-value-error">{numeral(totalValorCanceladas).format("$ 0,0.00")}</span>
            </div>
            <div className="summary-total-item summary-total-highlight">
              <span className="summary-total-label">Total geral</span>
              <span className="summary-total-value summary-value-primary">{numeral(totalValorAtivas + totalValorCanceladas).format("$ 0,0.00")}</span>
            </div>
          </div> */}

          <BootstrapTable className="TableDefault" data={items} selectRow={selectRowProp} options={options} trClassName={rowClassNameFormat} search pagination>
            <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
            <TableHeaderColumn dataField="chave" dataFormat={copyChaveFormatter} width="25%">Chave</TableHeaderColumn>
            <TableHeaderColumn dataField="numero" width="5%">Nº</TableHeaderColumn>
            <TableHeaderColumn dataField="tipo" width="8%">Tipo</TableHeaderColumn>
            <TableHeaderColumn dataField="cnpj" width="20%">Emitente/Destinatário</TableHeaderColumn>
            <TableHeaderColumn dataField="emissao" width="10%">Emissão</TableHeaderColumn>
            <TableHeaderColumn dataField="valor" dataFormat={valorFormatter} width="10%" >Valor</TableHeaderColumn>
            <TableHeaderColumn dataField="visualizar" dataFormat={buttonFormatter} width="5%">Ver</TableHeaderColumn>
            <TableHeaderColumn dataField="Origem" width="7%">Origem</TableHeaderColumn>
            <TableHeaderColumn dataFormat={buttonCancelada} dataField="cancelada" width="5%">Cancelada</TableHeaderColumn>
            <TableHeaderColumn dataField="Ações" thStyle={{ textAlign: "center" }} tdStyle={{ textAlign: "center" }} dataFormat={actionFormatter} width="10%">Ações</TableHeaderColumn>
          </BootstrapTable>

          <div style={{ marginBottom: 100 }} />

          </div>

        } />

        <Tab id="tarefas" title="Tarefas NFSe" panel={ <TarefasPage /> } />

        {/* <Tab id="nfe_export" title="Tarefas Exportar" panel={ <NFesExportPage /> } /> */}

      </Tabs>

      
    );
  }
}

export default NFesPage;
